import { render, staticRenderFns } from "./InspectionRequestForm.vue?vue&type=template&id=67dcb585&"
import script from "./InspectionRequestForm.vue?vue&type=script&lang=js&"
export * from "./InspectionRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports